SystemJS.import('/SiteAssets/js/core-client-common-library.min.js').then(function (pag) {
    
    var currentLocale = _spPageContextInfo.currentCultureName.split("-")[0].toLowerCase();
    $("#link_volver_conferencias").attr('href','/' + currentLocale + '/areas-tematicas/conferencias-jornadas');  

})
.catch(function (error) {
    console.log('Error loadChangeLinkVolverSettings.js', error);
});




